import baseRequest from "./requests/base-request";
import apiRequest from "./requests/api-request";

export default Object.assign({}, baseRequest,apiRequest);

